import type { ReactNode } from "react";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";

export function FormPageState({ title, children }: { title: string; children: ReactNode }) {
  const { goBack } = useAppNavigation();
  return (
    <Page>
      <PageHeader title={title} actions={<PageHeaderAction onClick={goBack}>Back</PageHeaderAction>} />
      <PageContent>{children}</PageContent>
    </Page>
  );
}
